import React, {useContext} from "react";
import GlobalStateContext from "../../store/GlobalStateContext";

const EventSwitcher = (props) => {
    const { currentEvent, mode } = props;
    const { setGlobalState } = useContext(GlobalStateContext);

    const _onClick = (e) => {
        e.preventDefault();

        setGlobalState({
            showEventSwitcher: true,
            eventSwitcherMode : mode,
        });
    }

    // return <div style={{textAlign: 'center'}}>
    return    <span className={"btn--event-switcher"} onClick={_onClick}>
            { currentEvent.title }
            <i>▼</i>
        </span>
    // </div>
}

export default EventSwitcher;